export const footerLinks = [
  {
    title: 'Sobre',
    links: [
      {
        text: 'Quem somos',
        href: `${process.env.NEXT_PUBLIC_APP_URL}/quem-somos/`,
      },
      {
        text: 'Portal Afya',
        href: process.env.NEXT_PUBLIC_PORTAL_AFYA,
      },
    ],
  },
  {
    title: 'Suporte',
    links: [
      {
        text: 'Contato',
        href: 'https://help.pebmed.com.br/hc/pt-br/',
      },
      {
        text: 'Pedido do titular',
        href: `${process.env.NEXT_PUBLIC_APP_URL}/pedido-do-titular/`,
      },
    ],
  },
  {
    title: 'Jurídico',
    links: [
      {
        text: 'Termos de uso',
        href: `${process.env.NEXT_PUBLIC_APP_URL}/termos-de-uso-afya-whitebook/`,
      },
      {
        text: 'Diretrizes editoriais',
        href: `${process.env.NEXT_PUBLIC_APP_URL}/diretrizes-editoriais/`,
      },
      {
        text: 'Diretrizes e política',
        href: `${process.env.NEXT_PUBLIC_APP_URL}/privacidade/`,
      },
    ],
  },
];

export const socialMediaLinks = [
  {
    icon: 'facebook',
    href: 'https://www.facebook.com/whitebookoficial/',
  },
  {
    icon: 'instagram',
    href: 'https://www.instagram.com/whitebookoficial/',
  },
  {
    icon: 'x',
    href: 'https://x.com/appwhitebook?lang=pt-BR',
  },
  {
    icon: 'youtube',
    href: 'https://www.youtube.com/@afya.oficial',
  },
  {
    icon: 'linkedin',
    href: 'https://www.linkedin.com/company/9331858',
  },
];
